import React from 'react';
import { NavLink, Route, Routes, Navigate } from 'react-router-dom';
import TemplatesPage from './TemplatesPage';
import TemplateEditorPage from './TemplateEditorPage';
import MilestonesPage from './MilestonesPage';
import SchedulePage from '../SchedulePage';
import './WorkflowHubPage.css';

/**
 * Workflow Hub
 * Connects Templates (PRD3), Milestones (PRD2), and Schedule (PRD4)
 * into a single navigable feature with nested routes.
 */
const WorkflowHubPage: React.FC = () => {
  const tabs = [
    { to: 'templates', label: 'Templates' },
    { to: 'milestones', label: 'Milestones' },
    { to: 'schedule', label: 'Schedule' },
  ];

  return (
    <div className="workflow-hub">
      <header className="workflow-hub__header">
        <div>
          <p className="workflow-hub__eyebrow">Workflow & Scheduling</p>
          <h1 className="workflow-hub__title">Workflow Hub</h1>
          <p className="workflow-hub__subtitle">
            Build templates, apply them to projects, manage milestones, and visualize schedules—all in one place.
          </p>
        </div>
        <div className="workflow-hub__cta">
          <NavLink className="btn btn-primary" to="templates/create">
            New Template
          </NavLink>
        </div>
      </header>

      <nav className="workflow-hub__tabs" aria-label="Workflow Hub Sections">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `workflow-hub__tab ${isActive ? 'workflow-hub__tab--active' : ''}`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <div className="workflow-hub__body">
        <Routes>
          <Route index element={<Navigate to="templates" replace />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="templates/create" element={<TemplateEditorPage />} />
          <Route path="templates/:templateId/edit" element={<TemplateEditorPage />} />
          <Route path="milestones" element={<MilestonesPage />} />
          <Route path="milestones/:projectId" element={<MilestonesPage />} />
          <Route path="schedule" element={<SchedulePage />} />
        </Routes>
      </div>
    </div>
  );
};

export default WorkflowHubPage;
